<template>
    <div>
        <!--面包屑-->
        <breadcrumb-link :title="getTitle"></breadcrumb-link>
        <!--内容区域-->
        <div>
            <el-button class="floatClass" type="info" size="small" plain @click="goBack" v-if="getDisabled">返回</el-button>
            <el-form :model="dataList" ref="dataList" label-width="130px" :disabled="getDisabled" :rules="rules">
                <div class="edit-title">基础信息 </div>
                <el-form-item label="kafka集群名称：" prop="name">
                    <el-input v-model="dataList.name" placeholder="名称不能超过50个字符" style="width: 800px;"></el-input>
                </el-form-item>
                <el-form-item label="kafka集群地址：" prop="clusterAddress">
                    <el-input v-model="dataList.clusterAddress" placeholder="请输入kafka集群地址" style="width: 800px;"></el-input>
                </el-form-item>
                <div class="centerClass">
                    <el-button type="primary" @click="submitForm('dataList')" v-if="type != 'details'">保存
                    </el-button>
                    <el-button type="info" plain @click="goBack" v-if="!getDisabled">返回</el-button>
                </div>
                <!--资源配置-->
                <kafka-config-table v-if="$route.query.id"></kafka-config-table>
                <!--记录信息-->
                <history-record :historyTitle="historyTitle" :historyList="historyList" v-if="getDisabled" />
            </el-form>
        </div>
    </div>
</template>

<script>
import kafkaConfigTable from "./componet/kafkaConfigTable";
import BreadcrumbLink from "../../components/breadcrumbLink";
import util from "@/utils/util";
import HistoryRecord from "../../components/common/historyRecord";
import DialogTips from "../../components/dialogTips";
import {
    getKafkaDetail,
    addOrEditKafka
} from "@/apis/pipelineService/kafkaService";

export default {
    components: {
        DialogTips,
        HistoryRecord,
        BreadcrumbLink,
        kafkaConfigTable
    },
    data() {
        return {
            type: "", // 跳转页面获取标题
            dataList: {
                name: "", // 物理库名称
                clusterAddress: "" // 集群地址
            },
            historyTitle: "记录信息", // 记录信息标题
            historyList: [
                {
                    label: "创建人：",
                    value: ""
                },
                {
                    label: "创建时间：",
                    value: ""
                },
                {
                    label: "最后修改人：",
                    value: ""
                },
                {
                    label: "最后修改时间：",
                    value: ""
                }
            ], // 记录信息信息内容
            id: this.$route.query.id,
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入kafka集群名称",
                        trigger: "blur"
                    },
                    {
                        min: 1,
                        max: 50,
                        message: "名称不能超过50个字符",
                        trigger: "blur"
                    }
                ],
                clusterAddress: [
                    {
                        required: true,
                        message: "请输入kafka集群名称",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    computed: {
        getDisabled() {
            return {
                add: false,
                edit: false,
                details: true
            }[this.type];
        },
        getTitle() {
            return {
                add: "新增集群配置",
                edit: "修改集群配置",
                details: "集群配置详情"
            }[this.type];
        }
    },
    mounted() {
        this.type = this.$route.query.type;
        if (this.type != "add") {
            this.getDetails();
        }
    },
    methods: {
        // 返回上一层
        goBack() {
            this.$router.push({
                path: "/kafkaConfig"
            });
        },
        //列表时间格式化
        dateFormat(timestamp) {
            if (timestamp) {
                return util.timestampToTime13(timestamp);
            }
            return "--";
        },
        // 详情
        async getDetails() {
            let params = {
                id: this.id
            };
            try {
                const data = await getKafkaDetail(params);
                if (data.code == 0 && data.data) {
                    this.dataList = data.data;
                    this.historyList = [
                        {
                            label: "创建人：",
                            value: data.data.creatorName
                        },
                        {
                            label: "创建时间：",
                            value: this.dateFormat(data.data.createTime)
                        },
                        {
                            label: "最后修改人：",
                            value: data.data.updatorName
                        },
                        {
                            label: "最后修改时间：",
                            value: this.dateFormat(data.data.updateTime)
                        }
                    ];
                }
            } catch (error) {}
        },
        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.pushForm();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 提交
        async pushForm() {
            let params = {
                id: this.id,
                name: this.dataList.name,
                clusterAddress: this.dataList.clusterAddress
            };
            if (this.type == "add") {
                delete params.id;
            }
            try {
                const data = await addOrEditKafka(params);
                if (data.code == 0) {
                    this.$router.push({
                        path: "/kafkaConfigForm",
                        query: {
                            type: "edit",
                            id: data.data.id || this.$route.query.id
                        }
                    });
                    this.type = 'edit'
                    this.$message.success(data.message);
                } else {
                    this.$message.error(data.message);
                }
            } catch (error) {}
        }
    }
};
</script>

<style scoped lang="scss">
.flexInline {
    display: flex;
}
.info {
    width: 100%;
    margin: 0 auto;
    background: #f8f8f8;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
}
.centerClass {
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    .el-button {
        margin: 0 20px;
    }
}
.floatClass {
    float: right;
}
</style>
